import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { BiArrowBack } from 'react-icons/bi';

import styles from './FormBooks.module.css';

import Button from '../../components/Button';
import InputForm from '../../components/InputForm';
import Title from '../../components/Title';

export default function FormBooks() {
  const token = localStorage.getItem('accessToken');
  const navigate = useNavigate();
  const [authorId, setAuthorId] = useState(null);
  const [book, setBook] = useState({
    titulo: '',
    genero: '',
    anoLancamento: '',
    preco: '',
    sinopse: '',
    tipo_venda: 'whatsapp_autor',
    link_venda: '',
    autor_id: '',
    capa: null
  });

  useEffect(() => {
    if(!token) return;
    try {
      const decodedToken = jwtDecode(token);
      setAuthorId(decodedToken.id);
    } catch (error) {
      console.error('Erro ao decodificar token', error);
    }
  }, [token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBook({
      ...book,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setBook({
      ...book,
      capa: file,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!book.capa) {
      alert('Por favor, selecione a capa do livro');
      return;
    }
    
    const formData = new FormData();
    formData.append('titulo', book.titulo);
    formData.append('genero', book.genero);
    formData.append('anoLancamento', book.anoLancamento);
    formData.append('preco', book.preco);
    formData.append('sinopse', book.sinopse);
    formData.append('tipo_venda', book.tipo_venda);
    formData.append('link_venda', book.link_venda);
    formData.append('autor_id', authorId);
    formData.append('capa', book.capa);

    axios.post('https://back-cultura-sje-production.up.railway.app/create-book', formData, {
      headers: { 
        Authorization: `Bearer ${ token }`,
        'Content-Type': 'multipart/form-data' 
      }
    })
      .then(() => {
        setBook({
          titulo: '',
          genero: '',
          anoLancamento: '',
          preco: '',
          sinopse: '',
          tipo_venda: '',
          link_venda: '',
          autor_id: '',
          capa: null
        });

        alert('Livro cadastrado com sucesso.')
      })
      .catch((error) => {
        console.error('Erro no envio do formulario',  JSON.stringify(error, null, 2));
      }) 
    };

    const handleGoBack = () => {
      navigate('/autores/painel');
    };

  return (
    <main className={styles.page}>
      <div className={styles.container}>
        <button onClick={handleGoBack} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <BiArrowBack size={24} />
          Voltar
        </button>
        <Title color='var(--brown-300)'>Cadastro de Livros</Title>
        <form onSubmit={handleSubmit} className={styles.formContainer}>
          <InputForm 
            mode='input'
            type='text'
            name='titulo'
            title='Título'
            placeholder='Digite o título do livro'
            value={book.titulo}
            onChange={handleChange}
          />
          <InputForm 
            mode='input'
            type='text'
            name='genero'
            title='Gênero'
            placeholder='Digite o gênero do livro'
            value={book.genero}
            onChange={handleChange}
          />
          <InputForm 
            mode='input'
            type='number'
            name='anoLancamento'
            title='Ano de Lançamento'
            placeholder='Digite o Ano de Lançamento'
            value={book.anoLancamento}
            onChange={handleChange}
          />
          <InputForm 
            mode='input'
            type='number'
            name='preco'
            title='Preço'
            placeholder='Digite o preço do livro'
            value={book.preco}
            onChange={handleChange}
          />
          <InputForm 
            mode='textarea'
            type='text'
            name='sinopse'
            title='Sinopse'
            placeholder='Fale um pouco sobre o seu livro'
            value={book.sinopse}
            onChange={handleChange}
          />
          <InputForm 
            mode='select'
            name='tipo_venda'
            title='Tipo de venda'
            value={book.tipo_venda}
            onChange={handleChange}
            options={[
              { name: 'Whatsapp do autor', value: 'whatsapp_autor' },
              { name: 'Whatsapp do sebo', value: 'whatsapp_sebo' },
              { name: 'Link', value: 'link' },
              { name: 'Esgotado', value: 'esgotado' }
            ]}
          />
          <InputForm 
            mode='input'
            type='text'
            name='link_venda'
            title='link'
            placeholder='Cole o link caso seja sua opção de venda'
            required={false}
            value={book.link}
            onChange={handleChange}
          />
          <InputForm 
            mode='input'
            type='file'
            name='capa'
            title='Capa do livro'
            onChange={handleFileChange}
            accept='image/*'
          />
          <div className={styles.button}>
            <Button>Enviar</Button>
          </div>
        </form>
      </div>
    </main>
  )
}
